import { extend } from "vee-validate";
import i18n from "@/i18n/i18n";

extend('placeholder_validator', {
  validate: (value) => /^[a-z_0-9]+$/gi.test(value),
  message: () => i18n.t('validator_allowed_characters_error_message', [ 'a-z A-Z 0-9 _' ]).toString(),
})
